module.exports = "<style>.angular-loading-bar-spinner{position:fixed;top:80px;left:50%;transform:translate(-50%,-50%);z-index:100}</style> <div class=angular-loading-bar-spinner> &nbsp; </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./src/portal/init/angular-loading-bar/spinner.html
// module id = 1142
// module chunks = 0